import {Typography} from 'components/Typography';
import {FC, useState} from 'react';
import style from './style.module.scss';
import {animated, useSpring} from '@react-spring/web';
import useMeasure from 'react-use-measure';

const MIN_WIDTH = 24;

interface IProps {
    src: string;
    title: string;
}

const AnimatedTypography = animated(Typography);

export const Shield: FC<IProps> = ({src, title}) => {
    const [isHovered, setHovered] = useState(false);

    const [ref, {width: outerWidth}] = useMeasure();

    const props = useSpring({
        width: isHovered ? outerWidth : MIN_WIDTH,
        opacity: isHovered ? 1 : 0,
        config: {
            duration: 300,
        },
    });

    return (
        <>
            <animated.div
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                className={style.main}
                style={{width: props.width}}
            >
                <div className={style.content} ref={ref}>
                    <img alt={title} className={style.image} src={src} />
                    <AnimatedTypography
                        className={style.title}
                        variant={'label-14-r-fluid'}
                        style={{opacity: props.opacity}}
                    >
                        {title}
                    </AnimatedTypography>
                </div>
            </animated.div>
        </>
    );
};
